import script from "./Mail.vue?vue&type=script&setup=true&lang=js"
export * from "./Mail.vue?vue&type=script&setup=true&lang=js"

import "./Mail.vue?vue&type=style&index=0&id=63898231&lang=css"

const __exports__ = script;

export default __exports__